import { render, staticRenderFns } from "./AppPortaleTurystyczne.vue?vue&type=template&id=99c1e82c&"
import script from "./AppPortaleTurystyczne.vue?vue&type=script&lang=js&"
export * from "./AppPortaleTurystyczne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports